import {Component, Prop, Vue} from 'vue-property-decorator'
import theme, {customClasses, customCss, gradientAngle} from '@/lib/vuetify/theme'
import ColorHelper from '@/lib/ColorHelper'

interface Theme {
  [key: string]: string
}

export default class VuetifyColorHelper {
  public static theme(): Theme {
    return theme ? theme : Vue.prototype.$vuetify.theme
  }

  public static color(c: string) {
    const t = this.theme()
    return t[c] !== undefined ? t[c] : c
  }

  public static isCssColor(color?: string | false): boolean {
    return !!color && !!color.match(/^(#|(rgb|hsl)a?\()/)
  }

  public static css(c: string) {
    return Object.keys(customCss).includes(c) ? customCss[c] : null
  }

  public static gradientAngle(c: string) {
    return Object.keys(gradientAngle).includes(c) ? gradientAngle[c] : null
  }

  public static classes(c: string) {
    return Object.keys(customClasses).includes(c) ? customClasses[c] : null
  }
}

@Component
export class CustomColorableMixin extends Vue {
  @Prop({type: String}) protected customCSS!: string
  @Prop({type: String, default: () => ''}) protected colorTop?: string
  @Prop({type: String, default: () => ''}) protected colorBottom?: string
  @Prop({
    default: 180,
    type: Number,
  }) protected angle?: number | string
  @Prop({type: Boolean, default: () => false}) protected ripple?: boolean
  @Prop({type: Boolean}) protected light?: boolean
  @Prop({type: Boolean}) protected dark?: boolean
  @Prop({type: Boolean, default: true}) protected flat?: boolean

  protected get customCss() {
    if (VuetifyColorHelper.css(this.customCSS)) {
      return VuetifyColorHelper.css(this.customCSS)
    }
    return null
  }

  protected get customStyle() {
    const arr = []
    if (this.colorTop && this.colorBottom) {
      arr.push({
        'background-image': `linear-gradient(${this.gradientAngle || this.angle}deg, ${this.color(this.colorTop)}, ${this.color(this.colorBottom)})`,
      })
    } else {
      arr.push({
        background: VuetifyColorHelper.color('primary'),
      })
    }
    if (this.customCss) {
      arr.push(this.customCss)
    }
    return arr
  }

  protected get customClasses() {
    return VuetifyColorHelper.classes(this.customCSS)
  }

  protected get gradientAngle() {
    if (VuetifyColorHelper?.gradientAngle(this.customCSS)) {
      return VuetifyColorHelper.gradientAngle(this.customCSS)
    }
    return this.angle || null
  }

  protected get contrastOverride() {
    switch (VuetifyColorHelper.color(this.customCSS + 'ContrastOverride')) {
      case 'light':
        return true
      case 'dark':
        return false
    }
  }

  protected get isLight() {
    const top = this.colorTop ? this.color(this.colorTop) : null
    const bottom = this.colorBottom ? this.color(this.colorBottom) : null
    if (this.contrastOverride !== undefined) {
      return this.contrastOverride
    } else if (top && bottom) {
      return ColorHelper.lightContrast(top, bottom)
    }
    return !this.$vuetify.dark
  }

  protected color(c: string) {
    return VuetifyColorHelper.color(c) !== c ? VuetifyColorHelper.color(c) : null
  }
}
